<script>

  import { find } from 'lodash'
  import { handleUpsell } from '../modules/helpers'
  import { toTitleCase } from '../modules/toTitleCase'
  import { modals, tag_to_remove, font_id_to_tag, user, user_valid } from '../stores'
  import { tags_are_being_edited, user_font_tags, previews_are_google_fonts } from '../stores'
  
  export let tag_ids
  export let hovering_parent
  export let zoomed_parent
  export let font_id

  let hovering = false

  function tagidToName(id) {
    return $previews_are_google_fonts ? toTitleCase(id) : find($user_font_tags, {'id': id}).tag_name
  }

  function openRemoveModal(tag_id) {
    if (!$tags_are_being_edited) return
    $tag_to_remove = {tag_id: tag_id, font_id: font_id}
    modals.open('removeTag')
  }

  function handleAddClick() {
    $font_id_to_tag = font_id
    modals.open('saveTag')
    handleUpsell('tag_button', true)
  }
</script>

{#if (hovering_parent || $tags_are_being_edited)}
<div class="PreviewTags" 
  class:hovering
  class:zoomed_parent
  class:editing={$tags_are_being_edited}
  on:mouseenter={() => hovering = true}
  on:mouseleave={() => hovering = false}>
  {#if tag_ids}
    {#each tag_ids as tagid}
      <span on:click={() => openRemoveModal(tagid)}>
        {(hovering || $tags_are_being_edited) ? tagidToName(tagid) : tagidToName(tagid).charAt()}
        {#if $tags_are_being_edited}
          <b>&times;</b>
        {/if}
      </span>
    {/each}
  {/if}
  {#if !!$user && !$previews_are_google_fonts}
    <button 
      class="add" 
      title="Tag this font"
      class:pro_only_no_demo={!$user_valid}
      on:click={handleAddClick}>
      +
    </button>
  {/if}
</div>
{/if}

<style>
  div {
    --pill-width: 2rem;
    --pill-offset: 0.3rem;
    display: flex;
    flex-flow: wrap;
    justify-content: flex-end;
    position: absolute;
    right: 0.4rem;
    bottom: 0.8rem;
    text-align: right;
    background-color: var(--c-content-bg);
  }
  div span,
  div button.add {
    display: inline-block;
    width: var(--pill-width);
    height: var(--pill-width);
    padding: 0 0.4rem;
    margin-right: calc( -2 * var(--pill-offset));
    overflow: hidden;
    text-align: center;
    font-size: 1.3rem;
    font-weight: 500;
    line-height: 1.4rem;
    letter-spacing: 0.02rem;
    border: 2px solid var(--c-content-bg);
    border-radius: Calc(var(--pill-width) / 2);
    background-color: var(--c-pill-bg);
    color: var(--c-content-bg);
    transition: all var(--transition-props);
  }
  div span:last-child {
    margin-right: 0;
  }
  div.hovering span,
  div.editing span {
    width: unset;
    color: var(--c-text);
    margin-right: 0;
    padding: 0 0.6rem;
    cursor: default;
  }
  div button.add {
    cursor: pointer;
    display: inline-block;
    margin-right: 0;
    padding: 0 0.3rem;
    font-size: 1.7rem;
    font-weight: bold;
    line-height: 1.8rem;
  }
  div button.add:hover {
    color: var(--c-text-on-fill-hover);
    background-color: var(--c-button-bg);
  }
  div button.add::after {
    top: -1.5rem;
  }

  b {
    font-size: 1.8rem;
    line-height: 0.8rem;
    display: inline-block;
    font-weight: 400;
    font-family: var(--Helvetica);
    transform-origin: center;
  }
  div.editing span:hover {
    cursor: pointer;
    color: var(--c-text-on-fill-hover);
    background-color: var(--c-danger);
  }
  div.editing span:hover b {
    font-weight: 600;
  }
  div.zoomed_parent {
    bottom: 2.7rem;
    right: calc(2.6rem + var(--pill-offset));
  }
</style>